// utils/statusPriority.js

export const CHARGER_STATUS_PRIORITY = {
  Available: 1,
  Charging: 2,
  Preparing: 3,
  Finishing: 4,
  Reserved: 5,
  SuspendedEVSE: 6,
  Faulted: 7,
  Inactive: 8,
};

export const SESSION_STATUS_PRIORITY = {
  Active: 1,
  Unpaid: 2,
  Completed: 3,
};

export const sortByStatusPriority = (
  data = [],
  priorityMap = {},
  secondaryKey
) => {
  return [...data].sort((a, b) => {
    const pA = priorityMap[a.status] ?? 99;
    const pB = priorityMap[b.status] ?? 99;

    // Primary: status priority
    if (pA !== pB) return pA - pB;

    // Secondary (optional): latest first
    if (secondaryKey && a[secondaryKey] && b[secondaryKey]) {
      return new Date(b[secondaryKey]) - new Date(a[secondaryKey]);
    }

    return 0;
  });
};
